import { useEffect } from 'react';
import audioService from '../services/audioService';
import { AUDIO_CONFIG } from '../config/constants';

/**
 * Custom hook to handle volume control with smooth transitions
 * @param {GainNode} gainNode - The Web Audio API gain node
 * @param {number} volume - Volume value (0-100)
 */
export const useVolumeControl = (gainNode, volume) => {
  useEffect(() => {
    if (gainNode) {
      const normalizedVolume = audioService.normalizeVolume(volume);
      audioService.setVolume(gainNode, normalizedVolume, AUDIO_CONFIG.VOLUME_TRANSITION_TIME);
    }
  }, [gainNode, volume]);
};

/**
 * Custom hook to handle stereo panning width control
 * @param {Object} panNodes - Object containing left and right pan nodes
 * @param {number} panWidth - Pan width value (0-100)
 */
export const usePanControl = (panNodes, panWidth) => {
  useEffect(() => {
    if (panNodes) {
      const normalizedPanWidth = panWidth / AUDIO_CONFIG.VOLUME_NORMALIZE_FACTOR;
      audioService.setPanWidth(panNodes, normalizedPanWidth);
    }
  }, [panNodes, panWidth]);
};

export default useVolumeControl;
